module.exports = __webpack_public_path__ + "img/closeIconBlue.57e61fa4.svg";